/// <reference path='../../docs-and-forms.module.ts' />
/// <reference path='../../../../../../typings/index.d.ts' />
///<reference path="../../docs-and-forms.models.ts"/>
///<reference path="../../docs-and-forms-api.service.ts"/>
///<reference path="../../docs-and-forms-render.service.ts"/>
///<reference path="../../../../components/modal/modal.interface.ts"/>


module Meevo.Plugins.DocsAndForms {


    interface IDocsAndFormsSystemTagsComponentScope extends ng.IScope {

    }

    class DocsAndFormsSystemTagsComponent implements ng.IComponentController {

        static $inject = [
            '$scope',
            'meevo.plugins.docsAndForms.DocsAndFormsApiService',
            'meevo.plugins.docsAndForms.DocsAndFormsRenderService',
        ];

        public docsAndFormsModel: IDocsAndFormsModel;
        public formBuilderModel: IFormBuilderModel;
        public disabled: boolean;

        public systemTagsList: ISystemTag[];

        constructor(private $scope: IDocsAndFormsSystemTagsComponentScope,
            private docsAndFormsApiService: DocsAndFormsApiService,
            private docsAndFormsRenderService: DocsAndFormsRenderService) {
            this.systemTagsList = [];
        }

        private loadSystemTags() {
            this.systemTagsList = this.docsAndFormsRenderService.getSystemTagsList(this.docsAndFormsModel.formFillTypeEnum, this.docsAndFormsModel.tabTypeEnum, this.docsAndFormsModel.builderHTML);
            const todayTag = this.systemTagsList.find(tag => tag.readableKey === "TodayDateTime");
            if (todayTag) {
                todayTag.readOnly = true;
            }         
            this.formBuilderModel.selectedSystemTagsNames = this.systemTagsList
                .filter(tag => tag.selected);
        }

        $onInit() {
            this.loadSystemTags();
            this.initializeWatchers();
            this.updateSelectedCheckboxes();
        }

        public updateSelectedCheckboxes() {
            this.formBuilderModel.selectedSystemTagsNames = this.systemTagsList
                .filter(tag => tag.selected);
        }

        private initializeWatchers() {
            this.$scope.$watch(() => this.formBuilderModel, () => { this.loadSystemTags(); });
        }
    }

    angular.module('meevo.plugins.docsAndForms')
        .component('docsAndFormsSystemTagsComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/docsAndForms/components/system-tags/docs-and-forms-system-tags.component.html',
            controller: DocsAndFormsSystemTagsComponent,
            controllerAs: '$ctrl',
            bindings: {
                docsAndFormsModel: '=',
                formBuilderModel: '=',
                disabled: '=?ngDisabled',
            }
        });

}
